import { ContextMenu as ContextMenuComponent } from '@finviz/website'
import React from 'react'
import * as ReactDOM from 'react-dom'

import { ObjectHash } from '../../types/shared'
import model from '../models/context_menu'
import { ready } from '../utils'

const selector = '.context-menu'

class ContextMenu extends React.Component {
  componentDidMount() {
    model.bind('update', this.update)
  }

  componentWillUnmount() {
    model.unbind('update', this.update)
  }

  update = () => {
    this.forceUpdate()
  }

  render() {
    if (model.shown) {
      document.querySelector(selector)?.classList.remove('hidden')
    } else {
      document.querySelector(selector)?.classList.add('hidden')
      return null
    }

    return (
      <>
        <div
          className="overlay select-none"
          onClick={() => this.hide()}
          onContextMenu={(e) => e.preventDefault()}
          data-testid="charts-context-menu-overlay"
        ></div>
        <ContextMenuComponent top={model.top} left={model.left} items={model.config} hide={this.hide} />
      </>
    )
  }

  hide() {
    model.updateAttribute('shown', false)
  }
}
ready(() => {
  const el = document.querySelector(selector)
  if (el) {
    ReactDOM.render(<ContextMenu />, el)
  }
})

const contextMenuControl = {
  show: (event: MouseEvent | React.MouseEvent, config: ObjectHash) => {
    model.updateAttributes({
      shown: true,
      config: config,
      top: event.clientY + window.pageYOffset,
      left: event.clientX,
    })
  },
}

export default contextMenuControl
